import { render, staticRenderFns } from "./TreatmentAdd.vue?vue&type=template&id=02892603"
import script from "./TreatmentAdd.vue?vue&type=script&lang=js"
export * from "./TreatmentAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports